export var SEND_EVENTS = 'SEND_EVENTS';
export var SET_TC_VARIABLES = 'SET_TC_VARIABLES';
export var RESET_TC_VARIABLES = 'RESET_TC_VARIABLES';